import { useEffect } from 'react';

import { Navigate } from 'react-router-dom';

import { AgendaRoutePathEnum } from '@setup/router/routes/agenda/agenda-route-path-enum';
import { AuthRoutesPathEnum } from '@setup/router/routes/auth/authRoutesPath.enum';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { setBreadcrumbs } from '@store/Common/commonThunk';

const Home = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setBreadcrumbs([{ title: 'Home' }]));
  }, [dispatch]);
  const { isAuth } = useAppSelector(({ common }) => common);

  return isAuth ? (
    <Navigate
      to={{
        pathname: AgendaRoutePathEnum.agenda,
      }}
    />
  ) : (
    <Navigate
      to={{
        pathname: AuthRoutesPathEnum.auth,
      }}
    />
  );
};

export default Home;
